/* eslint-disable array-callback-return */
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from 'src/components/ui-component/mui-accordion/MUIAccordionComponent';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import DeleteRecord from 'src/lib/api/DeleteRecord';
import GetRecords from 'src/lib/api/GetRecords';
import { APIS } from 'src/lib/constants/apis';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, ERLAUTERUNG_IN_KOSTEN_TITLE, KOSTEN_ARTEN, KOSTEN_POSITION } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, GetMinMaxIntValidation, Required } from 'src/lib/validation/ValidationTypes';
import { checkIfSpecificKostenPositionHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import { withKostenkategorieEinsatzbereichFilter } from 'src/utils/einsatzbereichHelper';
import { getFormStrucComponentTable } from 'src/utils/formStruc';
import {
	addIndexesToPath,
	checkReadOnlyInUeberarbeitung,
	getFieldNamefromDataPath,
	getOptionsFromRes,
	removeDataKeys,
	removeNullDeep,
} from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getBasisDataKostenKategorie,
	getKostenErlauterung,
} from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = KostenPositionSchema.attributes;

const PersonalKostenAntragLogMob: FC<{ kostentraeger: string; unternehmenId?: number; hasComment?: boolean }> = ({
	kostentraeger,
	unternehmenId,
	hasComment,
}) => {
	const { application, setApplicationProperty, readOnly, saveApplication } = useApplication();
	const [kostenKategorie, setKostenKategorie] = useState([]);

	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const handleAddPersonalkosten = async () => {
		let appCopy = cloneDeep(application);

		const data = getBasisDataKostenKategorie(
			appCopy,
			kostenKategorie, // All kostenkategorie for Personalkosten, to find default Kostenkategorie id
			kostentraeger,
			unternehmenId,
			KOSTEN_POSITION.Ausgabe,
			KOSTEN_ARTEN.Personalkosten,
		);
		set(data, getFieldNamefromDataPath(KP_P.Personalausgaben_Logistik_Mobilitaet.path), {
			[getFieldNamefromDataPath(KP_P.Personalausgaben_Logistik_Mobilitaet.schema.attributes.Logistik_Mobilitaet_Antrag_Projekt_Jahr.path)]:
				Array.from({
					length: get(appCopy, P.Allgemein_Projektdauerin_Jahren.path, 0),
				}).map((_, i) => {
					return {
						Zelle_1: parseInt(get(appCopy, P.Allgemein_Projektstart_Jahr.path)) + i,
					};
				}),
		});
		set(
			appCopy,
			addIndexesToPath(
				P.Foerderantrag_Kostenpositions.path,
				[`${get(application, P.Foerderantrag_Kostenpositions.path, []).length}`],
				['Foerderantrag_Kostenpositions'],
			),
			{ attributes: data },
		);
		saveApplication(false, appCopy);
	};
	const handleDeletePersonalKosten = async (id: number) => {
		// autofold/fold_next
		try {
			let appcopy = cloneDeep(application);
			const allKostenposition = get(appcopy, P.Foerderantrag_Kostenpositions.path, []);
			set(
				appcopy,
				P.Foerderantrag_Kostenpositions.path,
				allKostenposition.filter((item: any) => item.id !== id),
			);
			let res = await DeleteRecord(APIS.Kostenposition, id);
			if (res) {
				saveApplication(false, appcopy);
			}
		} catch (err: any) {
			console.error('ERROR: Deleting Personalkosten', err);
		}
	};
	// Fetch KostenKategories
	useEffect(() => {
		// autofold/fold_next
		const fetch = async () => {
			try {
				const filter = withKostenkategorieEinsatzbereichFilter(
					{
						Allgemein_Kostenposition: KOSTEN_POSITION.Ausgabe,
						Allgemein_Kostenart_Finanzierung: KOSTEN_ARTEN.Personalkosten,
						Allgemein_Antragsformular: { $contains: get(application, P.Allgemein_Antragsformular.path) },
						Allgemein_Aktiv: { $eq: true },
					},
					APIS.Antrag,
				);
				let res = await GetRecords(APIS.Kostenkategorie, [], filter);
				setKostenKategorie(removeNullDeep(removeDataKeys(get(res, 'data'))));
			} catch (err: any) {
				console.error('ERROR: Fetching Kostenkategorie ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{get(application, P.Foerderantrag_Kostenpositions.path, []).map((ele: any, i: number) => {
				if (
					get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
					get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten &&
					get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
				) {
					return (
						<MUIAccordionComponent
							key={i}
							summaryTitle={`Personalkosten ${get(ele, KP_P.Personalausgaben_Logistik_Mobilitaet.schema.attributes.Personalausgaben_Logistik_Mobilitaet_Name_Desder_Beschaeftigten.path, '')}`}
							onDelete={() => handleDeletePersonalKosten(get(ele, 'id'))}
							showDeleteButton={!updatedReadOnly}
							hasComment={checkIfSpecificKostenPositionHasComment(readOnly, ele)}
						>
							<PruefAssistenz
								statusPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Pruefstatus.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								hinweisPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Hinweis_Fuer_Antragsteller.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								ueberarbeitetAmPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								erledigtPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								formStruc={mapPersonalKosten(PruefAssistenzStruc(), i)}
							/>

							<MUIAlert
								title={ERLAUTERUNG_IN_KOSTEN_TITLE}
								message={getKostenErlauterung(kostenKategorie, get(ele, KP_P.Allgemein_Kostenkategorie.path))}
							/>

							<Grid2 container spacing={6}>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapPersonalKosten(formStruc1(kostenKategorie), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
										size='small'
									/>
								</Grid2>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapPersonalKosten(formStruc2(), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
										size='small'
									/>
								</Grid2>
							</Grid2>
							<CreateForm
								formStruc={mapPersonalKosten(KalkulationBlockStruc(application, i), i)}
								formValues={application}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={updatedReadOnly}
								api={APIS.Kostenposition}
								size='small'
							/>
						</MUIAccordionComponent>
					);
				}
			})}
			{unternehmenId ?
				<Button sx={{ mt: '2rem' }} endIcon={<AddIcon />} onClick={handleAddPersonalkosten} disabled={updatedReadOnly}>
					Personalkosten hinzufügen
				</Button>
			:	<MUIAlert message='Für diesen Partner wurden noch keine Daten ausgefüllt. Bitte tragen Sie die Partnerdaten zuerst ein.' />}
		</>
	);
};
export default PersonalKostenAntragLogMob;

const PruefAssistenzStruc = () => {
	// autofold/fold_next
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc1 = (kostenKategorie?: any[]) => {
	let kategorieOptions = kostenKategorie || [];
	return [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kostenkategorie,
					type: 'enumeration',
					options: getOptionsFromRes(kategorieOptions, 'Allgemein_Bezeichnung'),
				},
				P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
					.Personalausgaben_Logistik_Mobilitaet_Name_Desder_Beschaeftigten,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
						.Personalausgaben_Logisti_0025437828_e_Personalausgaben_Pro_Monat,
					format: 'currency',
				},
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
						.Personalausgaben_Logistik_Mobilitaet_Beschaeftigung_Monate,
					validation: [{ validateFunction: Required }, { validateFunction: GetMinMaxIntValidation, params: [1, 12] }],
				},
			],
			userProps: { columnToDivide: 2 },
		},
	];
};
const formStruc2 = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
						.Personalausgaben_Logisti_0093996978_ekte_Personalausgabenim_Jahr,
					format: 'currency',
					disabled: true,
				},
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
						.Personalausgaben_Logistik_Mobilitaet_Std_Wochelt_Arbeitsvertrag,
					validation: [{ validateFunction: Required }, { validateFunction: GetMinMaxIntValidation, params: [1, 48] }],
				},
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
						.Personalausgaben_Logistik_Mobilitaet_max_Arbeitstage,
					disabled: true,
				},
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
						.Personalausgaben_Logistik_Mobilitaet_max_Einsatzstunden,
					disabled: true,
				},
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
						.Personalausgaben_Logistik_Mobilitaet_Stunden_Pro_Tag,
					disabled: true,
				},

				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
						.Personalausgaben_Logistik_Mobilitaet_Stundensatz,
					format: 'currency',
					disabled: true,
				},
			],
			userProps: { columnToDivide: 2 },
		},
	];
	// autofold/fold_next
	return struc;
};
const KalkulationBlockStruc = (application: any, i: number) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
						.Logistik_Mobilitaet_Antrag_Projekt_Jahr,
					type: 'componentTable',
					tableLabel: 'Ausgaben pro Jahr',
					disabledColumns: ['Zelle_1', 'Zelle_3'],
					fieldProps: { Zelle_3: { format: 'currency' } },
					maxLevel: get(application, P.Allgemein_Projektdauerin_Jahren.path),
					hideDeleteButton: true,
					width: 'fit-content',
					sumRow: [
						{
							id: 'pinnedRow',
							Zelle_1: 'Gesamt',
							Zelle_2: get(
								application,
								addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
										.Personalausgaben_Logistik_Mobilitaet_Projektjahr_Block_2_Zelle_2.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								),
							),
							Zelle_3: get(
								application,
								addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Logistik_Mobilitaet.schema.attributes
										.Personalausgaben_Logistik_Mobilitaet_Projektjahr_Block_2_Zelle_3.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								),
							),
						},
					],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const mapPersonalKosten = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Foerderantrag_Kostenpositions.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Foerderantrag_Kostenpositions.path.length),
				};
			}),
		};
	});
	return result;
};

export function getFormStrucPersonalKostenAntragLogMob(application: any, unternehmenId?: number): FormStrucItem[] {
	let formStruc: FormStrucItem[] = [];

	get(application, P.Foerderantrag_Kostenpositions.path, []).forEach((ele: any, i: number) => {
		if (
			get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
			get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten &&
			get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
		) {
			const isHinweisFieldRequired = checkIfPruefAssitenzNeedsToValidate(ele, KP_P.Pruefung_Pruefstatus.path, KP_P.Pruefung_Erledigt.path);

			const formStrucCT2WithIndex = getFormStrucComponentTable(application, mapPersonalKosten(KalkulationBlockStruc(application, i), i));
			const formStruc1WithIndex = mapPersonalKosten(formStruc1(), i);
			const formStruc2WithIndex = mapPersonalKosten(formStruc2(), i);

			if (isHinweisFieldRequired) {
				formStruc = concat(
					mapPersonalKosten(PruefAssistenzStruc(), i),
					formStruc,
					formStruc1WithIndex,
					formStruc2WithIndex,
					formStrucCT2WithIndex,
				);
			} else {
				formStruc = concat(formStruc, formStruc1WithIndex, formStruc2WithIndex, formStrucCT2WithIndex);
			}
		}
	});
	return formStruc;
}
